import { Base64 } from "js-base64"

export enum MLSortDirection {
  DESC = 'DESC',
  ASC = 'ASC',
}

export enum FileType {
  images = 'images',
  videos = 'videos',
  cssJs = 'cssJs',
  others = 'others',
}

export enum MLSortParams {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  NAME = 'NAME',
  HEIGHT = 'HEIGHT',
  WIDTH = 'WIDTH',
  SIZE = 'SIZE',
  RELEVANCE = 'RELEVANCE',
}

export enum MLViewType {
  LIST = 'LIST',
  GRID = 'GRID',
}

export enum ACLEntityTypeEnum {
  USER = 'USER',
  USER_GROUP = 'USER_GROUP',
  MEDIA_COLLECTION = 'MEDIA_COLLECTION',
}

export enum ACLPermissionEnum {
  READ = 'READ',
  CONTRIBUTE = 'CONTRIBUTE',
  MANAGE = 'MANAGE',
}

export const DEFAULT_SEARCH_NAME_AUTOCOMPLETE_SKIP = 0

export const DEFAULT_SEARCH_NAME_AUTOCOMPLETE_LIMIT = 15

export enum UrlRewriterEum {
  CLOUDINARY = 'CLOUDINARY',
  IMGIX = 'IMGIX',
  AKAMAI = 'AKAMAI',
}

export enum PostTransformationTypes {
  Transformation = 'transformation',
  GifToVideo = 'gif-to-video',
  Thumbnail = 'thumbnail',
  ABS = 'abs',
}

export enum PostTransformationLabels {
  Transformation = 'Transformation',
  GifToVideo = 'Gif to video',
  Thumbnail = 'Thumbnail',
  ABS = 'ABS',
}

export enum Protocol {
  HLS = 'HLS',
  DASH = 'DASH',
}

export enum ProtocolValue {
  HLS = 'hls',
  DASH = 'dash',
}

export enum ThreadSort {
  DESC_CREATED = 'DESC_CREATED',
  DESC_UPDATED = 'DESC_UPDATED',
}

export enum ThreadFilter {
  UNRESOLVED = 'UNRESOLVED',
  ALL = 'ALL',
}

export enum ThreadAction {
  ADD = 'add',
  REMOVE = 'remove',
}

export const MaxPostTransformation = 5

export const BLANK_SEARCH_QUERY_PARAMS: {
  fileType: FileType | ""
  sort: string
  view: MLViewType
  searchQuery: string
  q: string
  semantic: string
  semanticUrl: string
  type: string
  isFolderRestrictedSearch: string
  searchMode: string
  searchInputMode: string
  searchByTags: string
  isVersionIncludedInSearch: string
} = {
  sort: 'DESC_CREATED',
  view: MLViewType.GRID,
  searchQuery: '',
  q: '',
  fileType: "",
  searchMode: 'keyword',
  searchInputMode: 'builder',
  searchByTags: 'true',
  isVersionIncludedInSearch: 'false',

  // legacy
  isFolderRestrictedSearch: 'false',
  type: Base64.encode('type="file"', true),
  semantic: '',
  semanticUrl: '',
}